module.exports = __webpack_public_path__ + "img/login-logo.a43fde01.png";